<template>
  <b-modal
    :id="modalID"
    size="lg"
    body-class="p-0"
    @shown="getLink"
    @hide="closeModal"
  >
    <template #modal-header>
      <div
        class="d-flex justify-content-between align-items-center px-gd-3"
        style="width: 100%"
      >
        <h3 class="fs-db-28 mb-0">
          {{ $t("engine.modal.addlink.lblTitle", languageEngine) }}
        </h3>
        <div
          class="d-flex justify-content-between align-items-center"
          type="button"
          style="font-size: 18px"
        >
          <i class="fal fa-question-circle mr-5"></i>
          <div
            @click="closeModal()"
            type="button"
            aria-label="Close"
            id="close-modal-manage-header-menu"
            class="close-modal"
          >
            <i class="fal fa-times"></i>
          </div>
        </div>
      </div>
    </template>

    <div class="px-gd-5 d-flex" v-if="render">
      <div class="pt-gd-2 pr-gd-2">
        <h5 class="fs-dbb-20 mb-0">
          {{ $t("engine.modal.addlink.lblLinkType", languageEngine) }}
        </h5>
        <b-form-group>
          <b-form-radio
            class="pt-gd-2"
            v-model="linkType"
            value="url"
            v-if="isShowTypeUrl"
            ><p class="fs-sa-14 mb-0 cursor-pointer">
              {{ $t("engine.modal.addlink.linkType.lblUrl", languageEngine) }}
            </p></b-form-radio
          >
          <b-form-radio
            class="pt-gd-2"
            v-model="linkType"
            value="page"
            v-if="isShowTypePage"
            ><p class="fs-sa-14 mb-0 cursor-pointer">
              {{ $t("engine.modal.addlink.linkType.lblPage", languageEngine) }}
            </p></b-form-radio
          >
          <b-form-radio
            class="pt-gd-2"
            v-model="linkType"
            value="anchor"
            v-if="isShowTypeAnchor"
            ><p class="fs-sa-14 mb-0 cursor-pointer">
              {{
                $t("engine.modal.addlink.linkType.lblAnchor", languageEngine)
              }}
            </p></b-form-radio
          >
          <b-form-radio
            class="pt-gd-2"
            v-model="linkType"
            value="phone"
            v-if="isShowTypePhone"
            ><p class="fs-sa-14 mb-0 cursor-pointer">
              {{
                $t(
                  "engine.modal.addlink.linkType.lblPhoneNumber",
                  languageEngine
                )
              }}
            </p></b-form-radio
          >
          <b-form-radio
            class="pt-gd-2"
            v-model="linkType"
            value="email"
            v-if="isShowTypeEmail"
            ><p class="fs-sa-14 mb-0 cursor-pointer">
              {{ $t("engine.modal.addlink.linkType.lblEmail", languageEngine) }}
            </p></b-form-radio
          >
          <b-form-radio
            class="pt-gd-2"
            v-model="linkType"
            value="file"
            v-if="isShowTypeFile"
            ><p class="fs-sa-14 mb-0 cursor-pointer">
              {{
                $t("engine.modal.addlink.linkType.lblDocument", languageEngine)
              }}
            </p></b-form-radio
          >
        </b-form-group>
      </div>

      <div class="col pt-gd-2" style="border-left: solid 1px #dee3e6">
        <h5 class="fs-dbb-20 mb-0">
          {{ $t("engine.modal.addlink.lblSetting", languageEngine) }}
        </h5>

        <div id="url" class="pt-gd-2" v-if="linkType === 'url'">
          <div class="row align-items-center">
            <div class="col-4">
              <p class="fs-sa-14 mb-0">
                {{ $t("engine.modal.addlink.setting.lblUrl", languageEngine) }}
              </p>
            </div>
            <div class="col-8 d-flex align-items-center flex-column">
              <b-form-input placeholder="https://" v-model="url" />
            </div>
          </div>
          <div class="row">
            <div class="col-4"></div>
            <div class="col-8">
              <div
                v-if="error == 'url_error'"
                class="fs-sa-12 text-danger mb-0"
              >
                {{ $t("engine.modal.addlink.msgUrlError", languageEngine) }}
              </div>
              <div
                v-if="error == 'url_format_error'"
                class="fs-sa-12 text-danger mb-0"
              >
                {{
                  $t("engine.modal.addlink.msgUrlFormatError", languageEngine)
                }}
              </div>
            </div>
          </div>
          <div class="row pt-gd-2">
            <div class="col-4 d-flex align-items-center" style="width: 100%">
              <p class="fs-sa-14 mb-0">
                {{
                  $t(
                    "engine.modal.addlink.setting.lblOpenInNewWindow",
                    languageEngine
                  )
                }}
              </p>
            </div>
            <div class="col-8 d-flex align-items-center" style="width: 100%">
              <b-form-checkbox
                v-model="target"
                value="_blank"
                unchecked-value="_self"
              />
            </div>
          </div>
        </div>

        <div id="page" class="pt-gd-3" v-if="linkType === 'page'">
          <div class="row d-flex align-items-center">
            <div class="col-4">
              <p class="fs-sa-14 mb-0">
                {{
                  $t(
                    "engine.modal.addlink.setting.lblPage",
                    languageEngine
                  )
                }}
              </p>
            </div>
            <div class="col-8">
              <SelectPage v-model="pageID" class="w-100" />
            </div>
          </div>
          <div class="row">
            <div class="col-4"></div>
            <div class="col-8">
              <div
                v-if="error == 'page_error'"
                class="fs-sa-12 text-danger mb-0"
              >
                {{ $t("engine.modal.addlink.msgPageError", languageEngine) }}
              </div>
            </div>
          </div>
          <div class="row pt-gd-2">
            <div class="col-4 d-flex align-items-center">
              <p class="fs-sa-14 mb-0">
                {{
                  $t(
                    "engine.modal.addlink.setting.lblOpenInNewWindow",
                    languageEngine
                  )
                }}
              </p>
            </div>
            <div class="col-8 d-flex align-items-center">
              <b-form-checkbox
                v-model="target"
                value="_blank"
                unchecked-value="_self"
              />
            </div>
          </div>
        </div>

        <div id="anchor" class="pt-gd-3" v-if="linkType === 'anchor'">
          <div class="row align-items-center">
            <div class="col-4">
              <p class="fs-sa-14 mb-0">
                {{ $t("engine.modal.addlink.setting.lblPage", languageEngine) }}
              </p>
            </div>
            <div class="col-8">
              <SelectPage v-model="sectionPageID" class="w-100" />
            </div>
          </div>
          <div class="row">
            <div class="col-4"></div>
            <div class="col-8">
              <div
                v-if="error == 'anchor_page_error'"
                class="fs-sa-12 text-danger mb-0"
              >
                {{
                  $t("engine.modal.addlink.msgAnchorPageError", languageEngine)
                }}
              </div>
            </div>
          </div>
          <div class="row align-items-center pt-gd-2">
            <div class="col-4">
              <p class="fs-sa-14 mb-0">
                {{
                  $t("engine.modal.addlink.setting.lblSection", languageEngine)
                }}
              </p>
            </div>
            <div class="col-8">
              <SelectSection
                v-model="sectionID"
                :pageId="sectionPageID"
                class="w-100"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-4"></div>
            <div class="col-8">
              <div
                v-if="
                  error == 'anchor_page_error' ||
                  error == 'anchor_section_error'
                "
                class="fs-sa-12 text-danger mb-0"
              >
                {{
                  $t(
                    "engine.modal.addlink.msgAnchorSectionError",
                    languageEngine
                  )
                }}
              </div>
            </div>
          </div>
        </div>

        <div
          id="phoneNumber"
          class="mh-100 pt-gd-3"
          v-if="linkType === 'phone'"
        >
          <div class="row align-items-center">
            <div class="col-4 fs-sa-14 mb-0">
              {{
                $t(
                  "engine.modal.addlink.setting.lblPhoneNumber",
                  languageEngine
                )
              }}
            </div>
            <div class="col-8">
              <!-- <b-form-input placeholder="+12345678" v-model="phone" /> -->
              <VuePhoneNumberInput
                class="fs-sa-14 mb-0"
                v-model="phone.phoneNumber"
                @update="phone = $event"
                color="#24BEE2"
                :default-country-code="phoneCountry"
                show-code-on-list
              />
            </div>
          </div>

          <div class="row">
            <div class="col-4"></div>
            <div class="col-8">
              <div
                class="fs-sa-12 text-danger mb-0"
                v-if="error == 'phone_error'"
              >
                {{ $t("engine.modal.addlink.msgPhoneError", languageEngine) }}
              </div>
              <div
                class="fs-sa-12 text-danger mb-0"
                v-if="error == 'phone_format_error'"
              >
                {{
                  $t("engine.modal.addlink.msgPhoneFormatError", languageEngine)
                }}
              </div>
            </div>
          </div>

          <div
            class="fs-sa-12 text-muted mb-0 align-items-end"
            style="position: absolute; bottom: 10px"
          >
            {{ $t("engine.modal.addlink.msgPhone", languageEngine) }}
          </div>
        </div>

        <div id="email" class="pt-gd-3" v-if="linkType === 'email'">
          <div class="row align-items-center">
            <div class="col-4 fs-sa-14 mb-0">
              {{
                $t(
                  "engine.modal.addlink.setting.lblEmailAddress",
                  languageEngine
                )
              }}
            </div>
            <div class="col-8 fs-sa-14 mb-0">
              <b-form-input placeholder="info@mydomain.com" v-model="email" />
            </div>
          </div>
          <div class="row">
            <div class="col-4"></div>
            <div class="col-8">
              <div
                v-if="error == 'email_error' || error == 'email_and_subject_error'"
                class="fs-sa-12 text-danger mb-0"
              >
                {{ $t("engine.modal.addlink.msgEmailError", languageEngine) }}
              </div>
              <div
                v-if="error == 'email_format_error'"
                class="fs-sa-12 text-danger mb-0"
              >
                {{ $t("engine.modal.addlink.msgEmailFormatError", languageEngine) }}
              </div>
            </div>
          </div>
          <div class="row align-items-center mt-gd-2">
            <div class="col-4 fs-sa-14 mb-0">
              {{
                $t(
                  "engine.modal.addlink.setting.lblEmailSubject",
                  languageEngine
                )
              }}
            </div>
            <div class="col-8 fs-sa-14 mb-0">
              <b-form-input
                placeholder="Inquiry about additional service"
                v-model="emailSubject"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-4"></div>
            <div class="col-8">
              <div
                v-if="error == 'email_subject_error' || error == 'email_and_subject_error'"
                class="fs-sa-12 text-danger mb-0"
              >
                {{ $t("engine.modal.addlink.msgEmailSubjectError", languageEngine) }}
              </div>
            </div>
          </div>
        </div>

        <div id="file" class="pt-gd-3" v-if="linkType === 'file'">
          <div class="row align-items-center">
            <div class="col-4 fs-sa-14 mb-0">
              {{
                $t("engine.modal.addlink.setting.lblChooseFile", languageEngine)
              }}
            </div>
            <div class="col-8">
              <b-button variant="default" @click="openModalFile"
                ><i class="far fa-image mr-2"></i
                >{{
                  $t("engine.modal.addlink.setting.btnBrowse", languageEngine)
                }}</b-button
              >
            </div>
          </div>
          <div class="row">
            <div class="col-4"></div>
            <div class="col-8">
              <div
                v-if="error == 'file_error'"
                class="fs-sa-12 text-danger mb-0"
              >
                {{ $t("engine.modal.addlink.msgFileError", languageEngine) }}
              </div>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-4 mt-gd-3 fs-sa-14 mb-0">
              {{
                $t("engine.modal.addlink.setting.lblFileName", languageEngine)
              }}
            </div>
            <div class="col-8 mt-gd-3">
              <h5 class="fs-dbb-20 mb-0">{{ file.name }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #modal-footer>
      <div class="mx-20">
        <b-button variant="blue" class="mr-3" @click="setLink"
          ><i class="far fa-check mr-2"></i
          >{{
            $t("engine.modal.addlink.setting.btnSave", languageEngine)
          }}</b-button
        >
        <b-button variant="light" @click="closeModal">
          <i class="far fa-times mr-2"></i
          >{{
            $t("engine.modal.addlink.setting.btnCancel", languageEngine)
          }}</b-button
        >
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import SelectPage from "../AddLink/SelectPage.vue";
import SelectSection from "../AddLink/SelectSection.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import setObjectPath from "@helpers/setObjectPath.helper";
import { email } from "vuelidate/lib/validators";

export default {
  components: {
    SelectPage,
    SelectSection,
    VuePhoneNumberInput,
  },
  data() {
    return {
      modalID: "modal-add-link-widget",
      render: true,
      linkType: "url",
      phone: {
        phoneNumber: "",
        phoneFormat: "",
      },
      phoneCountry: "TH",
      email: "",
      emailSubject: "",
      url: "",
      target: "_blank",
      pageID: "",
      sectionPageID: "",
      sectionID: "",
      file: {},
      error: "",
      isShowError: false,
    };
  },
  computed: {
    ...mapGetters({
      modal: "design/modal",
      modalPayload: "design/modalPayload",
      components: "design/metadata/components",
      siteComponents: "design/metadata/siteComponents",
      languageEngine: "design/userPreference/languageEngine",
    }),
    properties() {
      return this.modalPayload.properties;
    },
    widgetID() {
      return this.modalPayload.id;
    },
    isShowTypeUrl() {
      return this.modalPayload && this.modalPayload.isShowTypeUrl == false
        ? false
        : true;
    },
    isShowTypePage() {
      return this.modalPayload && this.modalPayload.isShowTypePage == false
        ? false
        : true;
    },
    isShowTypeAnchor() {
      return this.modalPayload && this.modalPayload.isShowTypeAnchor == false
        ? false
        : true;
    },
    isShowTypePhone() {
      return this.modalPayload && this.modalPayload.isShowTypePhone == false
        ? false
        : true;
    },
    isShowTypeEmail() {
      return this.modalPayload && this.modalPayload.isShowTypeEmail == false
        ? false
        : true;
    },
    isShowTypeFile() {
      return this.modalPayload && this.modalPayload.isShowTypeFile == false
        ? false
        : true;
    },
    hasSite(){
       let checkSite = this.modalPayload.id in this.components;
        return checkSite;
    }
  },
  methods: {
    closeModal() {
      this.error = "";
      this.$store.dispatch("design/setModal", { name: "" });
      this.$bvModal.hide(this.modalID);
    },
    getLink() {
      this.linkType = this.properties.link.type || "url";
      this.url = this.properties.link.url || "";
      this.target = this.properties.link.target || "_blank";

      this.phoneCountry = this.properties.link.phoneCountry || "TH";
      this.phone.phoneNumber = this.properties.link.phone || "";

      this.email = this.properties.link.email || "";
      this.emailSubject = this.properties.link.emailSubject || "";

      this.pageID = this.properties.link.pageID || "";
      this.target = this.properties.link.target || "_blank";

      this.sectionPageID = this.properties.link.sectionPageID || "";
      this.sectionID = this.properties.link.sectionID || "";

      this.file.url = this.properties.link.fileUrl || "";
      this.file.name = this.properties.link.fileName || "";
      this.file.id = this.properties.link.fileID || "";
    },
    setLink() {
      this.linkType == "phone"
        ? this.setLinkPhone()
        : this.linkType == "email"
        ? this.setLinkEmail()
        : this.linkType == "url"
        ? this.setLinkUrl()
        : this.linkType == "file"
        ? this.setLinkFile()
        : this.linkType == "page"
        ? this.setLinkPage()
        : this.setLinkAnchor();
    },
    setLinkPhone() {
      if (this.phone && this.phone.phoneNumber !== "") {
        if (this.phone.isValid) {
          let component = this.components[this.widgetID];
          if (!this.hasSite) {
              component = this.siteComponents[this.modalPayload.id];
              setObjectPath(component, this.phone.countryCode, `${this.modalPayload.path}/link/phoneCountry`);
              setObjectPath(component, this.phone.phoneNumber, `${this.modalPayload.path}/link/phone`);
              setObjectPath(component, this.phone.formattedNumber, `${this.modalPayload.path}/link/phoneFormat`);
              setObjectPath(component, "phone", `${this.modalPayload.path}/link/type`);
              setObjectPath(component, true, `${this.modalPayload.path}/link/isEnableLink`);

              this.closeModal();
              this.$store.dispatch("design/snapshot/genSnapshot");
          } else {
            setObjectPath(
              component,
              this.phone.countryCode,
              `/properties/link/phoneCountry`
            ); // TH
            setObjectPath(
              component,
              this.phone.phoneNumber,
              `/properties/link/phone`
            ); // 65675432
            setObjectPath(
              component,
              this.phone.formattedNumber,
              `/properties/link/phoneFormat`
            ); // 65675432
            setObjectPath(component, "phone", `/properties/link/type`);
            setObjectPath(component, true, `/properties/isEnableLink`);

            this.closeModal();
            this.$store.dispatch("design/snapshot/genSnapshot");
          }
        } else {
          this.error = "phone_format_error";
        }
      } else {
        this.error = "phone_error";
      }
    },
    setLinkEmail() {
      if (this.email && this.emailSubject) {
        this.$v.$touch();
        if (this.$v.email.$invalid) {
          this.error = "email_format_error";
          this.isShowError = true;
        } else {
          let component = this.components[this.widgetID];
          if (!this.hasSite) {
              component = this.siteComponents[this.modalPayload.id];
              setObjectPath(component,  this.email, `${this.modalPayload.path}/link/email`);
              setObjectPath(component, "email", `${this.modalPayload.path}/link/type`);
              setObjectPath(component,  this.emailSubject,`${this.modalPayload.path}/link/emailSubject`);
              setObjectPath(component, true, `${this.modalPayload.path}/link/isEnableLink`);

              this.closeModal();
              this.$store.dispatch("design/snapshot/genSnapshot");
          } else {
              setObjectPath(component, this.email, `/properties/link/email`);
              setObjectPath(component, "email", `/properties/link/type`);
              setObjectPath(
                component,
                this.emailSubject,
                `/properties/link/emailSubject`
              );
              setObjectPath(component, true, `/properties/isEnableLink`);

              this.closeModal();
              this.$store.dispatch("design/snapshot/genSnapshot");
            }
        }
      } else if (!this.email && this.emailSubject){
        this.error = "email_error";
        this.isShowError = true;
      } else if (this.email && !this.emailSubject) {
        this.error = "email_subject_error";
        this.isShowError = true;
      } else if(!this.email && !this.emailSubject){
        this.error = "email_and_subject_error";
        this.isShowError = true;
      }
    },
    setLinkUrl() {
      if (this.url) {
        if (this.$helper.url.isValidUrl(this.url)) {

          let component = this.components[this.widgetID];
          if (!this.hasSite) {
              component = this.siteComponents[this.modalPayload.id];
              setObjectPath(component, this.url, `${this.modalPayload.path}/link/url`);
              setObjectPath(component, "url", `${this.modalPayload.path}/link/type`);
              setObjectPath(component, this.target, `${this.modalPayload.path}/link/target`);
              setObjectPath(component, true, `${this.modalPayload.path}/link/isEnableLink`);

              this.closeModal();
              this.$store.dispatch("design/snapshot/genSnapshot");
          } else {
              setObjectPath(component, this.url, `/properties/link/url`);
              setObjectPath(component, "url", `/properties/link/type`);
              setObjectPath(component, this.target, `/properties/link/target`);
              setObjectPath(component, true, `/properties/isEnableLink`);

              this.closeModal();
              this.$store.dispatch("design/snapshot/genSnapshot");
          }
        } else {
          this.error = "url_format_error";
          this.isShowError = true;
        }
      } else {
        this.error = "url_error";
        this.isShowError = true;
      }
    },
    setLinkPage() {
      if (this.pageID) {
        let component = this.components[this.widgetID];
        if (!this.hasSite) {
          component = this.siteComponents[this.modalPayload.id];
          setObjectPath(component, this.pageID, `${this.modalPayload.path}/link/pageID`);
          setObjectPath(component, "page", `${this.modalPayload.path}/link/type`);
          setObjectPath(component, this.target, `${this.modalPayload.path}/link/target`);
          setObjectPath(component, true, `${this.modalPayload.path}/link/isEnableLink`);

          this.closeModal();
          this.$store.dispatch("design/snapshot/genSnapshot");
        } else {
          setObjectPath(component, this.pageID, `/properties/link/pageID`);
          setObjectPath(component, "page", `/properties/link/type`);
          setObjectPath(component, this.target, `/properties/link/target`);
          setObjectPath(component, true, `/properties/isEnableLink`);

          this.closeModal();
          this.$store.dispatch("design/snapshot/genSnapshot");
        }
      } else {
        this.error = "page_error";
      }
    },
    setLinkAnchor() {
      if (this.sectionPageID && this.sectionID) {
        let component = this.components[this.widgetID];
        if (!this.hasSite) {
          component = this.siteComponents[this.modalPayload.id];
          setObjectPath(component, this.sectionPageID, `${this.modalPayload.path}/link/sectionPageID`);
          setObjectPath(component, "anchor", `${this.modalPayload.path}/link/type`);
          setObjectPath(component, this.sectionID, `${this.modalPayload.path}/link/sectionID`);
          setObjectPath(component, true, `${this.modalPayload.path}/link/isEnableLink`);
          this.$store.dispatch("design/snapshot/genSnapshot");
          this.closeModal();
        } else {
          setObjectPath(
            component,
            this.sectionPageID,
            `/properties/link/sectionPageID`
          );
          setObjectPath(component, "anchor", `/properties/link/type`);
          setObjectPath(component, this.sectionID, `/properties/link/sectionID`);
          setObjectPath(component, true, `/properties/isEnableLink`);
  
          this.closeModal();
          this.$store.dispatch("design/snapshot/genSnapshot");
        }
      } else {
        if (!this.sectionPageID) {
          this.error = "anchor_page_error";
        } else {
          this.error = "anchor_section_error";
        }
      }
    },
    setLinkFile() {
      if (this.file.url && this.file.name) {
        let component = this.components[this.widgetID];
        if (!this.hasSite) {
          component = this.siteComponents[this.modalPayload.id];
          setObjectPath(component, this.file.id, `${this.modalPayload.path}/link/fileID`);
          setObjectPath(component, this.file.url, `${this.modalPayload.path}/link/fileUrl`);
          setObjectPath(component, this.file.name, `${this.modalPayload.path}/link/fileName`);
          setObjectPath(component, "file", `${this.modalPayload.path}/link/type`);
          setObjectPath(component, true, `${this.modalPayload.path}/link/isEnableLink`);

          this.closeModal();
          this.$store.dispatch("design/snapshot/genSnapshot");
        } else {
          setObjectPath(component, this.file.id, `/properties/link/fileID`);
          setObjectPath(component, this.file.url, `/properties/link/fileUrl`);
          setObjectPath(component, this.file.name, `/properties/link/fileName`);
          setObjectPath(component, "file", `/properties/link/type`);
          setObjectPath(component, true, `/properties/isEnableLink`);
  
          this.closeModal();
          this.$store.dispatch("design/snapshot/genSnapshot");
        }
      } else {
        this.error = "file_error";
      }
    },
    setFile(files) {
      this.file = {
        name: files[0].name,
        url: files[0].url,
        id: files[0].id,
      };
    },
    openModalFile() {
      this.$store.dispatch("design/openFilemanager", {
        onChange: this.setFile,
        isShowDocument: true,
        isShowImage: false,
        isShowUnsplash: false,
        isShowFlaticon: false,
      });
    },
    clearData() {
      this.url = this.properties.link.url || "";
      this.target = this.properties.link.target || "_blank";

      this.phoneCountry = this.properties.link.phoneCountry || "TH";
      this.phone.phoneNumber = this.properties.link.phone || "";

      this.email = this.properties.link.email || "";
      this.emailSubject = this.properties.link.emailSubject || "";

      this.pageID = this.properties.link.pageID || "";
      this.target = this.properties.link.target || "_blank";

      this.sectionPageID = this.properties.link.sectionPageID || "";
      this.sectionID = this.properties.link.sectionID || "";

      this.file.url = this.properties.link.fileUrl || "";
      this.file.name = this.properties.link.fileName || "";
      this.file.id = this.properties.link.fileID || "";
    },
  },
  validations: {
    email: {
      email,
    },
  },
  watch: {
    modal: {
      handler() {
        if (this.modal == this.modalID) {
          this.$bvModal.show(this.modalID);
        }
      },
    },
    linkType: {
      handler() {
        this.clearData();
        this.error = "";
      },
    },
    url: {
      handler() {
        this.error = "";
      },
    },
    pageID: {
      handler() {
        this.error = "";
      },
    },
    sectionPageID: {
      handler() {
        this.error = "";
      },
    },
    sectionID: {
      handler() {
        this.error = "";
      },
    },
    phone: {
      deep: true,
      handler() {
        this.error = "";
      },
    },
    email: {
      handler() {
        this.error = "";
      },
    },
    emailSubject: {
      handler() {
        this.error = "";
      },
    },
    file: {
      deep: true,
      handler() {
        this.error = "";
      },
    },
  },
};
</script>

<style scoped>
.vue-phone-number-input >>> .input-country-selector {
  width: 100px !important;
}
.vue-phone-number-input >>> .country-selector__input {
  font-size: 14px !important;
  font-family: "sarabun";
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  padding-top: 0 !important;
  font-size: 14px;
  color: #373e44;
}
.vue-phone-number-input >>> .country-selector__list__item {
  font-family: Tahoma, sans-serif, Arial;
  font-size: 14px;
  color: #373e44;
}
.vue-phone-number-input >>> .country-selector__list__item:hover {
  background-color: #e4faff;
}
.vue-phone-number-input >>> .country-selector__list__item.selected {
  font-weight: normal;
  background-color: #24bee2;
}
.vue-phone-number-input >>> .country-selector__label {
  display: none;
}
.vue-phone-number-input >>> .country-selector__country-flag {
  top: 50%;
  transform: translateY(-50%);
}

.vue-phone-number-input
  >>> .input-tel__input[data-v-e59be3b4]:not(.no-country-selector) {
  margin-left: -10px;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}
</style>
